// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button[data-v-6dec996c]{display:flex;justify-content:space-between;width:100%}.product-level-button[data-v-6dec996c]{font-family:\"Din\",sans-serif,Georgia;font-size:1.75rem;line-height:1;padding-bottom:.75rem;padding-top:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
